import { Globe } from "./extras";

// "Vasundhara - The planet": a butterfly and petals drift up → rising past trees and clouds → the Earth, turned by touch → it swirls into the painting.
export const vasundhara = {
  slug: "vasundhara-the-planet",
  duration: 27,
  extra: Globe,
  stages: [
    { id: "gather", at: 0, hint: "the series gathers" },
    { id: "rise", at: 4.5, hint: "rising" },
    { id: "planet", at: 12, hint: "drag to turn the planet" },
    { id: "swirl", at: 20.5, hint: "" },
  ],
  touch: null,
  // rising past the clouds into space: countless painted star-glints, never an empty sky
  layers: [{ src: "/arcs/destiny/stars.webp", add: true, wrap: 3.48, th: 0.1, h: 8.4, y: 3.2, r: 4.85, shimmer: 0.6, glow: 0.3, opacity: 0.85, show: [8.2, 10.2, 19.5, 21.5] }],
  line: { text: "All of life is blessed to rest in the lap of nature.", from: 13, to: 26.5, pos: "low" },
  ambient: { scene: "summer", until: 99, then: [[8, "reveal"]] },
  look: { start: 0.0, lift: [0, 1], end: 0.0, yaw: [[0, 0], [27, 0]] },
  calm: { duration: 12, fade: [4, 8.5], line: [5.5, 11.5], backdrop: "planet", pos: "low" },
  speed: [[0, 1], [27, 1]],
  frag: `
uniform sampler2D uMap;
uniform vec4 uCrop;
uniform float uT, uAspect, uTileH, uRadius, uCy, uSurface;
varying vec3 vPos;
${"__NOISE__"}
float hash(float n){ return fract(sin(n * 127.1) * 43758.5453); }
vec3 tap(vec2 uv){
  vec2 m = 1.0 - abs(1.0 - mod(uv, 2.0));
  return texture2D(uMap, mix(uCrop.xy, uCrop.zw, m)).rgb;
}
float ell(vec2 p, vec2 c, vec2 r, float a){ p -= c; p = mat2(cos(a), -sin(a), sin(a), cos(a)) * p; return length(p / r); }
vec3 altitude(float X, float alt, float n2){
  vec3 c = mix(mix(vec3(0.75, 0.88, 0.98), vec3(0.35, 0.55, 0.85), smoothstep(4.0, 14.0, alt)), vec3(0.02, 0.03, 0.09), smoothstep(14.0, 24.0, alt));
  float cloud = smoothstep(0.55, 0.75, snoise(vec3(X * 0.25, alt * 0.45, 2.0)) * 0.5 + 0.5) * smoothstep(5.0, 7.0, alt) * (1.0 - smoothstep(13.0, 16.0, alt));
  c = mix(c, vec3(0.98), cloud * 0.9);
  float tree = smoothstep(0.45, 0.52, (snoise(vec3(X * 1.1, alt * 0.9, 5.0)) * 0.5 + 0.5) * (1.0 - smoothstep(2.5, 5.0, alt)) + 0.25 * (1.0 - smoothstep(1.0, 3.0, alt)));
  c = mix(c, mix(vec3(0.1, 0.36, 0.2), vec3(0.22, 0.5, 0.24), n2), tree);
  c = mix(c, mix(vec3(0.36, 0.62, 0.26), vec3(0.48, 0.7, 0.3), n2), 1.0 - smoothstep(0.6, 1.0, alt));
  return c;
}
void main(){
  float n = snoise(vPos * 0.6) * 0.5 + 0.5;
  float n2 = snoise(vPos * 3.0 + 4.0) * 0.5 + 0.5;
  float th = atan(vPos.x, -vPos.z);
  float rise = 26.0 * smoothstep(4.5, 11.5, uT);
  float settle = smoothstep(21.5, 26.5, uT);
  vec3 col;
  vec2 local;
  if (uSurface < 0.5) {
    float X = th * uRadius;
    float y = vPos.y;
    col = altitude(X, y + rise, n2);
    // a butterfly and petals from the two earlier journeys drifting up together
    float up = uT * 0.55;
    for (int i = 0; i < 9; i++){
      float fi = float(i);
      vec2 c = vec2((hash(fi) - 0.5) * 3.0 + 0.3 * sin(uT * 0.7 + fi), 0.4 + up + hash(fi + 4.0) * 1.6);
      vec2 p = vec2(X, y) - c;
      float a = uT * 0.9 + fi;
      p = mat2(cos(a), -sin(a), sin(a), cos(a)) * p;
      float petal = 1.0 - smoothstep(0.9, 1.0, length(vec2(p.x / (0.05 * (1.0 - clamp(p.y / 0.1, -1.0, 1.0) * 0.6)), p.y / 0.1)));
      col = mix(col, fi < 4.5 ? vec3(0.66, 0.16, 0.24) : vec3(0.98, 0.78, 0.3), petal * (1.0 - smoothstep(7.0, 9.0, uT)));
    }
    vec2 bp = vec2(X - 0.4 * sin(uT * 0.5), y - 1.1 - up);
    float sq = mix(1.0, 0.2, 0.5 + 0.5 * sin(uT * 7.0));
    vec2 q = vec2(abs(bp.x) / sq, bp.y) / 0.3;
    float w = min(ell(q, vec2(0.5, 0.18), vec2(0.5, 0.34), -0.4), ell(q, vec2(0.34, -0.24), vec2(0.3, 0.26), 0.45));
    col = mix(col, mix(vec3(0.45, 0.72, 0.83), vec3(0.08), smoothstep(0.8, 0.95, w)), (1.0 - smoothstep(0.94, 1.0, w)) * (1.0 - smoothstep(7.0, 9.0, uT)));
    local = vec2(X, y - uCy);
  } else if (uSurface < 1.5) {
    col = mix(mix(vec3(0.36, 0.62, 0.26), vec3(0.48, 0.7, 0.3), n2), vec3(0.02, 0.03, 0.09), smoothstep(5.0, 9.5, uT));
    local = vPos.xz;
  } else {
    col = mix(vec3(0.5, 0.72, 0.96), vec3(0.02, 0.03, 0.09), smoothstep(6.0, 11.0, uT));
    local = vPos.xz;
  }
  vec2 tile = vec2(uTileH * uAspect, uTileH);
  vec3 paint = tap(local / tile + 0.5);
  float drip = uSurface < 0.5 ? (10.0 - vPos.y) / 10.0 : 0.5 + length(vPos.xz) / (uRadius * 3.0);
  col = mix(col, paint, smoothstep(0.0, 0.25, settle * 1.3 - drip * 0.6 - n * 0.25));
  gl_FragColor = vec4(clamp(col, 0.0, 1.0), 1.0);
  #include <colorspace_fragment>
}`,
};
